import React, { useState, useContext, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { t } from 'i18next';
import { WelletContext } from '../../context/WelletContext';
import { fetchConectedAccounts } from '../../services/invite/inviteService';
import SkeletonGuestList from '../Skeletons/SkeletonGuestList';
import Money from '../Common/Money/Money';
import styles from './GuestList.module.css';

const UsersList = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const welletContext = useContext(WelletContext);
  const [users, setUsers] = useState([]);
  const history = useHistory();

  const getConectedAccounts = async () => {
    try {
      const result = await fetchConectedAccounts(welletContext);
      setUsers(result);
    } catch (error) {
      setError(error.response.data.errorCode);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getConectedAccounts();
  }, []);

  if (loading) {
    return <SkeletonGuestList />;
  }

  return (
    <>
      <div className='font-125 fw-700 text-lighter-gray mt-3'>{t('yourNetworkOfPromoters')}</div>
      <div className={styles.cardContainer}>
        <div className={styles.cardBox}>
          <div className={` ${styles.cardTitle} font-small fw-400 `}>{t('earnings')}</div>
          <div className={`${styles.cardNumber} font-1rem fw-600 text-left `}><Money value={users.summary.earnings} lowDecimals decimal={false} /></div>
        </div>
        <div className={styles.cardBox}>
          <div className={` ${styles.cardTitle} font-small fw-400 `}>{t('promoters')}</div>
          <div className={`${styles.cardNumber} font-1rem fw-600 text-left `}>{users.summary.allAccounts}</div>
        </div>
        <div className={styles.cardBox}>
          <div className={` ${styles.cardTitle} font-small fw-400 `}>{t('assets')} </div>
          <div className={`${styles.cardNumber} font-1rem fw-600 text-left `}>{users.summary.approved}</div>
        </div>
      </div>
      <div className={styles.tableContainer}>
        <table className={`mt-3 ${styles.customTable}`}>
          <thead>
            <tr>
              <th className='pr-0'>{t('Alias')}</th>
              <th className={`text-center`}>
                {t('sizeOf')}
                <br />
                {t('yourNetwork')}
              </th>
              <th className={`text-right pl-0 ${styles.autoWidth}`}>{t('incomeGenerated')}<br/>{t('last30days')}</th>
            </tr>
          </thead>
          <tbody>
            {users.items.map((account, index) => (
              <tr key={index}>
                <td className='pr-0 fw-600'>{account.userName}</td>
                <td className={`text-center font-small`}>
                  {account.childCount}
                </td>
                <td className={`text-right font-small pl-0 ${styles.autoWidth}`}>
                  <Money value={account.amount} lowDecimals decimal={false} />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {/* <div className='mt-2'>
        <div className='account-button' onClick={() => history.push('/my-network-users')}>
          {t('viewAllPromoters')}
        </div>
      </div> */}
    </>
  );
};

export default UsersList;
